import Vue from 'vue';
import VueI18n from 'vue-i18n';
import SearchDefaults from '@/types/SearchDefaults';
import deDE from '@/translations/de_DE';
import itIT from '@/translations/it_IT';
import deIT from '@/translations/de_IT';
import enGB from '@/translations/en_GB';
import plPL from '@/translations/pl_PL';
import esES from '@/translations/es_ES';
import nlNL from '@/translations/nl_NL';
import deAT from '@/translations/de_AT';
import frFR from '@/translations/fr_FR';
import huHU from '@/translations/hu_HU';
import frBE from '@/translations/fr_BE';
import nlBE from '@/translations/nl_BE';
import deCH from '@/translations/de_CH';
import frCH from '@/translations/fr_CH';
import itCH from '@/translations/it_CH';
import daDK from '@/translations/da_DK';
import svSE from '@/translations/sv_SE';
import fiFI from '@/translations/fi_FI';

Vue.use(VueI18n);

const messages = {
  de_DE: deDE,
  it_IT: itIT,
  de_IT: deIT,
  en_GB: enGB,
  pl_PL: plPL,
  es_ES: esES,
  nl_NL: nlNL,
  de_AT: deAT,
  fr_FR: frFR,
  hu_HU: huHU,
  fr_BE: frBE,
  nl_BE: nlBE,
  de_CH: deCH,
  fr_CH: frCH,
  it_CH: itCH,
  da_DK: daDK,
  sv_SE: svSE,
  fi_FI: fiFI,
};

export default new VueI18n({
  locale: SearchDefaults.locale,
  fallbackLocale: SearchDefaults.locale,
  messages,
});
